// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu {
  position: relative;
  display: inline-block;
}

.dropdown-trigger {
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  position: relative;
  z-index: 1;
}

.dropdown-trigger:hover {
  background-color: #f0f0f0;
  z-index: 1; /* Keep the same z-index even on hover */
}

.dropdown-content {
  position: absolute;
  right: 0;
  top: 100%;
  min-width: 160px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000; /* Much higher z-index */
  overflow: hidden;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.dropdown-item:first-child {
  border-top: none;
}

.dropdown-item + .dropdown-item {
  border-top: 1px solid #f0f0f0;
}

.dropdown-item.danger {
  color: #dc3545;
}

.dropdown-item.danger:hover {
  background-color: #fff5f5;
}

.three-dots-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px;
  transition: color 0.2s ease, background-color 0.2s ease;
  position: relative;
  z-index: 1;
}

.three-dots-icon:hover {
  color: #333;
  background-color: #f5f5f5;
  z-index: 1; /* Keep the same z-index even on hover */
}`, "",{"version":3,"sources":["webpack://./src/components/DropdownMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,UAAU,EAAE,wCAAwC;AACtD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc,EAAE,wBAAwB;EACxC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;EACvD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU,EAAE,wCAAwC;AACtD","sourcesContent":[".dropdown-menu {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-trigger {\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n  position: relative;\n  z-index: 1;\n}\n\n.dropdown-trigger:hover {\n  background-color: #f0f0f0;\n  z-index: 1; /* Keep the same z-index even on hover */\n}\n\n.dropdown-content {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  min-width: 160px;\n  background-color: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 10000; /* Much higher z-index */\n  overflow: hidden;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  transition: background-color 0.2s ease;\n  white-space: nowrap;\n}\n\n.dropdown-item:hover {\n  background-color: #f5f5f5;\n}\n\n.dropdown-item:first-child {\n  border-top: none;\n}\n\n.dropdown-item + .dropdown-item {\n  border-top: 1px solid #f0f0f0;\n}\n\n.dropdown-item.danger {\n  color: #dc3545;\n}\n\n.dropdown-item.danger:hover {\n  background-color: #fff5f5;\n}\n\n.three-dots-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #666;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 4px;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  position: relative;\n  z-index: 1;\n}\n\n.three-dots-icon:hover {\n  color: #333;\n  background-color: #f5f5f5;\n  z-index: 1; /* Keep the same z-index even on hover */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
